import axios from 'axios';
import qs from 'qs';
import {ApiErrorResponse} from '@di-shared/api/di/type';

export interface RequestHeaderInterceptor {
  (): Promise<Record<string, string>>;
}

export const diAxios = axios.create({
  // setCciBaseUrl 함수를 통해 설정
  baseURL: '',
  timeout: 20 * 1000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  allowAbsoluteUrls: false,
  withCredentials: true,
  paramsSerializer: {
    serialize: (params) => qs.stringify(params, {arrayFormat: 'repeat'}),
  },
});

let requestHeaderInterceptor: RequestHeaderInterceptor = () => Promise.resolve({});

diAxios.interceptors.request.use(
  async (config) => {
    const headers = await requestHeaderInterceptor();
    Object.entries(headers).forEach(([key, value]) => {
      config.headers[key] = value;
    });
    return config;
  },
  (error) => Promise.reject(error)
);

diAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // [2025-02-11:cy.seo] FIXME: 서버와 약속하여 이 조건 구체화
    // if (!error.response || !error.response.data || !isApiErrorResponse(error.response.data)) {
    //
    // response 가 없거나, 서버가 준 값이 없거나, 사전에 정의한 error 형상이 아니라면 재가공
    //   const response: ApiErrorResponse = {
    //     code: error.response?.status || error.code,
    //     message: error.message,    //   };
    //   return Promise.reject(response);

    if (!error.response || !error.response.data) {
      return Promise.reject(error);
    }
    return Promise.reject(error.response.data);
  }
);

export function setDiBaseUrl(baseUrl: string) {
  diAxios.defaults.baseURL = baseUrl;
}

export function setDiApiRequestHeaderInterceptor(interceptor: RequestHeaderInterceptor) {
  requestHeaderInterceptor = interceptor;
}

export function isApiErrorResponse(error: unknown): error is ApiErrorResponse {
  return error !== null && typeof error === 'object' && 'code' in error && 'message' in error && 'errors' in error;
}
